import { useEffect, useMemo, useState } from "react";
import useSelect from "~components/Form/hooks/useSelect";
import prepareForOptions from "~services/utils/prepareForOptions";
import { db } from "~/db/db";

import { getColumnIntoKey } from "~pages/PriceSearchV2/utils/initializerHelpers";

const useFunilObraJustificativa = ({ formikRef = null, name = "funilObraJustificativaId" }) => {
  const funilObraJustificativaSelect = useSelect("funilObraJustificativas");
  const [fila, setFila] = useState(null);
  const [funilObraJustificativa, setFunilObraJustificativa] = useState(0);
  const [funilObraJustificativas, setFunilObraJustificativas] = useState([]);
  const [funilObraJustificativaObjeto, setFunilObraJustificativaObjeto] = useState({});

  useEffect(() => {
    const fetchGroup = async () => {
      let data = [];
      await db.funilObraJustificativas.filter((a) => a.ativo).each((e) => data.push(e));

      setFunilObraJustificativas(data);
    };

    fetchGroup();
  }, []);

  const optionFunilObraJustificativas = useMemo(
    () => prepareForOptions(funilObraJustificativas, "nome", "id"),
    [funilObraJustificativas]
  );

  function onChangeFunilObraJustificativa(e) {
    funilObraJustificativaSelect.upDateValue(e.value);
    funilObraJustificativaSelect.upDateDefaultValue(e || "");
    if (formikRef?.current) {
      formikRef.current.setFieldValue(name, e.value);
      setTimeout(() => formikRef.current.setFieldTouched(name, true));
    }
    setFunilObraJustificativa(e.value);
  }

  function SetSelectFunilObraJustificativa(id) {
    if (funilObraJustificativas?.length) {
      const funilObraJustificativa = funilObraJustificativas.find((grupo) => grupo.id === id);
      if (funilObraJustificativa) {
        onChangeFunilObraJustificativa({
          value: funilObraJustificativa.id,
          label: funilObraJustificativa.nome,
        });
      }

      setFila(null);
    } else {
      setFila(id);
    }
  }

  useEffect(() => {
    if (fila && funilObraJustificativas?.length > 0) {
      SetSelectFunilObraJustificativa(fila);
    }

    if (funilObraJustificativas?.length > 0) {
      setFunilObraJustificativaObjeto(getColumnIntoKey({ data: funilObraJustificativas, prefix: "id-" }));
    }
  }, [fila, funilObraJustificativas]);

  function CleanForFilter(option) {
    onChangeFunilObraJustificativa(option);
  }

  return {
    funilObraJustificativaObjeto,
    funilObraJustificativas,
    optionFunilObraJustificativas,
    onChangeFunilObraJustificativa,
    SetSelectFunilObraJustificativa,
    funilObraJustificativa,
    funilObraJustificativaSelect,
    setFunilObraJustificativa,
    CleanForFilter,
  };
};

export default useFunilObraJustificativa;
